import { ReactNode } from 'react';
import clsx from 'clsx';

type Props = {
  children: ReactNode;
  className?: string;
};

const Section = ({ children, className }: Props) => {
  return (
    <section
      className={clsx(
        'relative h-full w-full rounded-[16px] border border-gray-400 border-opacity-30 px-[24px] py-[30px] mb-[20px]',
        className
      )}
    >
      {children}
    </section>
  );
};

export default Section;
